import type { FirebaseOptions } from 'firebase/app'
export function getConfig() {
  const env = import.meta.env;

  return {
    BACKEND_ENDPOINT: env.VITE_BACKEND_URL,
    FIREBASE_CONFIG: {
      apiKey: env.VITE_FB_API_KEY,
      authDomain: env.VITE_FB_AUTH_DOMAIN,
      projectId: env.VITE_FB_PROJECT_ID,
      storageBucket: env.VITE_FB_STORAGE_BUCKET,
      messagingSenderId: env.VITE_FB_MESSAGING_SENDER_ID,
      appId: env.VITE_FB_APP_ID,
      measurementId: env.VITE_FB_MEASUREMENT_ID
    } as FirebaseOptions,
  };
}
